export const Endpoint = () => `/api/v3/celery/addbottask`;
export const Csrf = () => `/api/v3/celery/token/`;
export declare const QueryKey: never;
export type Payload = {
    botName: string;
    every: number;
    period: string;
};
export type Response = void;
